import React, { useState } from 'react';
import DynamicTabsComponent from '../../components/DynamicTabs/DynamicTabsComponent';
import WorkReports from '../WorkReports/ViewWorkReport';
import ManagerCourseReportsComponent from './ManagerCourseReportsComponent';

const ManagerWorkReportsTabs = [
  {
    title: 'Work Reports',
    index: 0,
    component: <WorkReports />,
  },
  {
    title: 'Course Reports',
    index: 1,
    component: <ManagerCourseReportsComponent />,
  },
];

const ManagerWorkReportsComponent = () => {
  const [activeTab, setActiveTab] = useState(1);

  return (
    <div style={{ width: '100%', marginTop: '24px' }}>
      <DynamicTabsComponent
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        TabsList={ManagerWorkReportsTabs}
      />
    </div>
  );
};

export default ManagerWorkReportsComponent;
